let MakeAppointmentSummaryPage = {
  /* Function */
  init: function () {
    // Event handler for print button
    jQuery('.print-appointment').on('click', function () {
      window.print();
      return false;
    });

    let tireObj = MakeAppointmentSummaryPage.populateTireData();
    MakeAppointmentSummaryPage.populateApptInfo();

    let apptServicesObj = JSON.parse(window.sessionStorage.appointment_services);
    let apptContactObj = JSON.parse(window.sessionStorage.appointment_contact);
    let storeSelectedObj = window.sessionStorage.getItem('storeSelectedInSession')
    let smsOptIn = apptContactObj ? apptContactObj.optInPromotion : false;
    let storeSelectedInSession = storeSelectedObj ? storeSelectedObj : false;

    // confirmation_page_load — links the summary page to the booking via confirmation_id
    window.mjtPush && window.mjtPush('confirmation_page_load', {
      confirmation_id: sessionStorage.getItem('mjt_confirmation_id') || ''
    });
    // If the appointment is for New Tire(s), show div with tire verbiage
    if (apptServicesObj[0]["name"] == "New Tire(s)") {
      jQuery('#new-tires-appointment-message').show();
    }
    // If it is a tire appointment, push the tire values to the datalayer
    if (tireObj) {
      dataLayer.push({
        'event': 'makeAppointment',
        'tireSize': tireObj.size,
        'totalTireCost': tireObj.total,
        'smsOptIn': smsOptIn,
        'storeSelectedInSession': storeSelectedInSession,
        'journey_id': sessionStorage.getItem('mjt_journey_id'),
        'page_depth': parseInt(sessionStorage.getItem('mjt_page_depth')),
        'confirmation_id': sessionStorage.getItem('mjt_confirmation_id') || ''
      })
    }
    else {
      dataLayer.push({
        'event': 'makeAppointment',
        'smsOptIn': smsOptIn,
        'storeSelectedInSession': storeSelectedInSession,
        'journey_id': sessionStorage.getItem('mjt_journey_id'),
        'page_depth': parseInt(sessionStorage.getItem('mjt_page_depth')),
        'confirmation_id': sessionStorage.getItem('mjt_confirmation_id') || ''
      })
    }
  },
  populateTireData: function () {
    if (window.sessionStorage.appointment_tire) {
      let tireObj = JSON.parse(window.sessionStorage.appointment_tire);
      if (tireObj) {
        let tireImg = jQuery('#appt-tire-info-img-wrapper img');
        tireImg.prop('src', tireImg.prop('src') + tireObj.image); //add the actual image source

        let tireRebateText = 'estimated total price';
        tireObj.tireRebate ? tireRebateText += ' after rebate' : '';

        jQuery('#appt-tire-make-model').text(tireObj.makeModel);
        jQuery('#appt-tire-size').text(tireObj.size);
        jQuery('#appt-tire-sku').text(tireObj.sku);
        jQuery('#appt-tire-type').text(tireObj.type);
        jQuery('#appt-tire-qty').text(tireObj.qty);
        jQuery('#appt-tire-only-price').text(tireObj.tireOnlyPrice);

        let hideParentAddOns = true;
        let hideNoChildAddOns = true;

        let parentAddOnHtml = '';
        tireObj.fees.forEach((parent) => {
          if (parent.children.length > 0) {
            hideParentAddOns = false;

            let childrenListHtml = '';

            parent.children.forEach((child) => {
              childrenListHtml += `<li>${child}</li>`;
            });

            parentAddOnHtml +=
              `<div class="appt-parent-add-on">
								 <div class="appt-parent-add-on-info">
									 <div class="appt-add-on">
										 <input type="checkbox" checked disabled>
										 <label><h3>${parent.name}</h3></label>
									 </div>
									 <ul>${childrenListHtml}</ul>
								 </div>
								 <div class="appt-item-price add-on-item">
									 <div>${parent.feeTotal}</div>
								 </div>
							 </div>`;
          }
        });

        hideParentAddOns ? jQuery('#appt-parents-wrapper').hide() : jQuery('#appt-parents-wrapper').html(parentAddOnHtml);

        let noChildAddOnHtml = '';
        tireObj.fees.forEach((fee) => {
          if (fee.children.length === 0) {
            hideNoChildAddOns = false;

            noChildAddOnHtml +=
              `<div class="appt-add-on-item">
								<div class="appt-add-on">
									<input type="checkbox" checked disabled>
									<label>${fee.name}</label>
								</div>
								<div class="appt-item-price add-on-item">
									<div>${fee.feeTotal}</div>
								</div>
							</div>`;
          }
        });

        hideNoChildAddOns ? jQuery('#appt-add-on-fees').hide() : jQuery('#appt-add-on-fees-wrapper').html(noChildAddOnHtml);

        if (!tireObj.tireRebate) {
          jQuery('#appt-tire-rebate-wrapper').hide();
        }
        jQuery('#appt-tire-rebate').text(tireObj.tireRebate);
        jQuery('#appt-tire-rebate-label').text(tireObj.tireRebateDescription);
        jQuery('#appt-tire-rebate-text').text(tireRebateText);
        jQuery('#appt-tire-total-price').text(tireObj.total);

        jQuery('#make-appointment-wrapper').show();
        return tireObj;
      }
    }
  },
  populateApptInfo: function () {
    if (window.sessionStorage.appointment_services) {
      let servicesArr = JSON.parse(window.sessionStorage.appointment_services);
      let contactObj = JSON.parse(window.sessionStorage.appointment_contact);
      let dateObj = JSON.parse(window.sessionStorage.appointment_datetime);
	  let vehicleObj = JSON.parse(window.sessionStorage.appointment_vehicle);

      let serviceHTML;
      if (servicesArr.length) {
        serviceHTML = servicesArr
          .map(svc => `<p>${svc.name}</p>`)
          .reduce((prev, cur) => prev + cur);
      } else {
        serviceHTML = '<p>No services selected</p>';
      }

      jQuery('.service-list').html(serviceHTML);
      jQuery('#dateSummaryContent').text(dateObj.text);

      let customerHTML = `
        <p>${contactObj.firstName + " " + contactObj.lastName}</p>
        <p>${contactObj.phone}</p>
        <p>${contactObj.email}</p>`;

      jQuery('.cust-info').html(customerHTML);

	  if (vehicleObj.year) {
	  	let vehicle = `${vehicleObj.year + ", " + vehicleObj.make + ", " + vehicleObj.model + ", " + vehicleObj.option}`;
      	jQuery('.veh-info').text(vehicle);
		jQuery('#info-wrapper').show();
	  }
      //Session data is cleared in make-appointment-current-page.js
    }
  },
  removeSessionStorages: function () {
    //delete appointment related cookies
    document.cookie.split(';')
      .filter(item => item.includes('appt'))
      .forEach((cookie) => {
        document.cookie = cookie + '; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
      });

    //delete appointment info from session storage
    Object.keys(sessionStorage)
      .filter(key => key.includes('appointment'))
      .forEach((key) => {
        sessionStorage.removeItem(key);
      });
  }
}